import { executeRequest, Request } from '@jfs/network'
import { TRANSACTION } from '../../AppContants'
import { RootStore } from '../../data/store'
import { getNetworkResponseError, isStatusOK } from '../../util/utill'
import { APIEndPoints } from '../APIEndPoints'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'

const responseParser = (data: any, amount: any) => {
  if (isStatusOK(data)) {
    return { ...data.data, amount }
  } else {
    throw getNetworkResponseError(data?.data)
  }
}

const TYPE = 12
const ENTITY_ID = '100002000003382'
const ENTITY_ID_TRANSACTION = '100002000003381'
const METHOD_FOR_VALIDATE_BENEFICIARY = {
  type: '309',
  subType: '550',
}

const METHOD_FOR_TRANSACTION = {
  type: '425',
  subType: '612',
}

const getBody = (amount: string, screen: string) => {
  const method = screen === TRANSACTION ? METHOD_FOR_TRANSACTION : METHOD_FOR_VALIDATE_BENEFICIARY
  return {
    entity: {
      initiatingEntityId: RootStore?.agent?.session?.CHANNEL_ID, //Channel ID of APP.
      application: RootStore?.agent?.session?.CHANNEL_ID, //Channel ID of APP.
      type: TYPE, //Hardcoded
      entityId: screen !== TRANSACTION ? ENTITY_ID : ENTITY_ID_TRANSACTION, //Hardcoded
    },
    amount: {
      grossAmount: amount, //Amount entered by the user.
    },
    //This whole object value is Hard coded, we will get it from BE dev.
    queryParameters: {},
    method: {
      type: method.type,
      subType: method.subType,
    },
  }
}

export const getConvenienceFeeApi = (tokens: any, amount: string, screen: string) => {
  let config = sitConfig(tokens) as any
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier

  const request: Request<{}> = {
    apiPath: APIEndPoints.convenienceFee,
    method: 'POST',
    config: config,
    body: getBody(amount, screen),
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      return responseParser(data, amount)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw err
    })
}
